<template>
  <div id="exe">
    <TopTitle />
    <br>
    <div style="text-align: center;">
      <p style="font-weight: bold;font-size: 35px;color: #606266;">提升百倍效率，解放双手让您创造更高价值</p>
      <p>10个高效功能涵盖所有高频操作</p>
    </div>
    <br>
    <div class="block">
      <el-image :src="src1" class="img1"></el-image>
    </div>
<!--    <MenuList />-->
    <br>
    <Description />
    <br>
    <Content />
    <br>
    <br>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import FixedHeader from '@/components/FixedHeader'

import TopTitle from '@/components/index/TopTitle'
// import MenuList from '@/components/index/MenuList'
import Description from '@/components/index/Description'
import Content from '@/components/index/Content'
export default {
  name: 'Exe001',
  components: {
    Content,
    Description,
    // MenuList,
    TopTitle
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      src1: require('@/assets//images/top1.png')
    }
  }
}
</script>

<style lang="scss" scoped>
#home {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0;
  padding: 0;
  min-height: 2000px;
  ::v-deep.fixed-header {
    position:fixed;
    top:22px;
    width: 100%;
    z-index:999;
  }
  ::v-deep.top-fixed-header {
    position:fixed;
    background: red;
    color: white;
    top:0;
    width: 100%;
    z-index:999;
  }
  .el-container{
    margin: 0;
    padding: 0;
  }
  .el-header {
    color: #3492ed;
    background-color: white;
    line-height: 70px;
    position:fixed;
    z-index:20;
    width: 100%;
    top:0;
    left: 0;
    box-shadow: 0 5px 3px #eaebec;
  }
  .el-main {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  .el-footer {
    display: flex;
    color: white;
    width: 100%;
    line-height: 15px;
    /*background-color: #006cff;*/
    background: #396afc;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2948ff, #396afc);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2948ff, #396afc); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .img1{
    width: 700px;
    border: #f0f1f0 1px solid;
  }
}
</style>

